import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ADMIN_SESSION_KEY } from "../config/adminConfig";

const AdminProtectedRoute = () => {
  const location = useLocation();
  const isAdmin = sessionStorage.getItem(ADMIN_SESSION_KEY) === "true";

  if (!isAdmin) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
